<template>
  <div @click="clickOverlay()" aria-labelledby="bsModalLabel" class="modal fade" data-backdrop="static"
       data-keyboard="false" data-toggle="modal"
       id="bsModalNewsDetail" role="dialog" tabindex="-1">
    <div @click.stop class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button @click="close()" aria-label="Close" class="close" type="button"><span
            aria-hidden="true">&times;</span></button>
          <h4 class="modal-title text-left" id="bsModalLabel">{{ title }}</h4>
        </div>
        <div class="modal-body text-center">
          <div v-html="data"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsDetailModal',
  data() {
    return {
      title: '',
      data: ''
    }
  },
  methods: {
    clickOverlay: function() {
      // Hide modal
      this.close()
    },
    close() {
      $('#bsModalNewsDetail').modal('hide')
    }
  },
  mounted() {
    this.$bus.$on('news-detail-modal', (args) => {
      this.title = args.title
      this.data = args.data || null
      $('#bsModalNewsDetail').modal('show')
    })
  }
}
</script>

<style scoped></style>
